/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Wantedklassenstufe1Inputs */



/**

* @param {_Field_Wantedklassenstufe1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_wantedklassenstufe1 = /** @type {((inputs?: _Field_Wantedklassenstufe1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Wantedklassenstufe1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beworbene Klassenstufe")
});
export { _field_wantedklassenstufe1 as "_field_wantedKlassenstufe" }